/* eslint-disable react/prop-types */
import { Button, Grid, Link } from '@mui/material';
import { useForm } from 'react-hook-form';

import CustomSelectBox from 'components/CustomSelectBox/CustomSelectBox';

const SearchBidirectionalTemplate = ({
  setTemplateList,
  fullTemplateList,
  dropDownList,
  setPage,
}) => {
  const eventList = [...new Set(fullTemplateList.map((x) => x.fileName))];
  const {
    control,
    reset,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm({
    mode: 'all',
    defaultValues: {
      domain: '',
      templateType: '',
      event: '',
    },
  });

  const [watchdomain, watchtemplateType, watcheventName] = watch([
    'domain',
    'templateType',
    'eventName',
  ]);

  const searchTemplate = (data) => {
    const { domain, templateType, eventName } = data;
    let filteredList = [...fullTemplateList];
    if (domain) {
      filteredList = filteredList.filter((x) => x.source === domain);
    }

    if (templateType) {
      filteredList = filteredList.filter((x) => x.jsontypeCategory === templateType);
    }
    if (eventName) {
      filteredList = filteredList.filter((x) => x.fileName === eventName);
    }
    setTemplateList(filteredList);
    setPage(1);
  };

  return (
    <Grid container gap={1} m={0}>
      <Grid item lg={3} md={3} sm={12} xs={12}>
        <CustomSelectBox
          flexDirection="column"
          placeHolder="Source"
          options={dropDownList?.sourceList?.map((x) => ({ name: x, value: x }))}
          control={control}
          name="domain"
          errors={!!errors?.domain}
          errorText={errors?.domain?.message}
          displayEmpty
        />
      </Grid>
      <Grid item lg={3} md={3} sm={12} xs={12}>
        <CustomSelectBox
          flexDirection="column"
          placeHolder="Template Type"
          options={dropDownList?.jsontypesList?.map((x) => ({
            name: x?.displayValue,
            value: x?.actualValue,
          }))}
          control={control}
          name="templateType"
          errors={!!errors?.templateType}
          errorText={errors?.templateType?.message}
          displayEmpty
        />
      </Grid>
      <Grid item lg={3} md={3} sm={12} xs={12}>
        <CustomSelectBox
          flexDirection="column"
          placeHolder="File Name"
          options={eventList?.map((x) => ({
            name: x,
            value: x,
          }))}
          control={control}
          name="eventName"
          errors={!!errors?.eventName}
          errorText={errors?.eventName?.message}
          displayEmpty
        />
      </Grid>
      <Grid container item lg={2} gap={1} md={2} sm={12} xs={12} alignItems="center">
        <Button
          variant="contained"
          color="secondary"
          onClick={handleSubmit(searchTemplate)}
          disabled={!watchdomain && !watchtemplateType && !watcheventName}
        >
          Apply
        </Button>
        <Link
          component="button"
          variant="body2"
          color="secondary"
          onClick={() => {
            reset();
            setTemplateList(fullTemplateList);
          }}
        >
          Clear
        </Link>
      </Grid>
    </Grid>
  );
};

export default SearchBidirectionalTemplate;
